import config from "./config";

export default () => {
  document.addEventListener("DOMContentLoaded", () => {
    const styleContents = `
    .a11y-nav {
      position: absolute;
      top: 0;
      width: 100%;
      max-width: 100vw;
      padding: 0;
      margin: 0;
      list-style: none;
      opacity: 0;
      pointer-events: none;
      z-index: calc(var(--a11y-z-index) + 1);

      &:focus-within {
        opacity: 1;
        pointer-events: all;
      }

      a {
        background-color: var(--a11y-color-widget-bg);
        left: 0;
        padding: 14.25px 24px;
        position: absolute;
        right: 0;
        font-weight: 600;
        text-align: center;
        text-decoration-skip-ink: auto;
        color: var(--a11y-color-widget-text);
        opacity: 0;
        hyphens: auto;

        &:focus {
          opacity: 1;
        }
      }
    }

    .a11y-scroll {
      all: unset;
    }
    `;

    const style = document.createElement("style");
    style.innerHTML += styleContents;
    let head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(style);

    const a11yNav = document.createElement('ul');
    a11yNav.id = 'nav-access';
    a11yNav.className = 'a11y-nav';

    const navItems = {
      'skip-to-main': {
        href: '',
        target: null,
        label: 'Zum Hauptinhalt'
      },
      'skip-to-a11y': {
        href: '',
        target: null,
        label: 'Zu den Barrierefreiheitseinstellungen'
      },
      'go-to-a11y-disclaimer': {
        href: config.a11yDisclaimerUrl,
        target: '_blank',
        label: 'Zur Barrierefreiheitserklärung'
      }
    };

    const scrollIntoViewWithOffset = (selector: string, offset: number) => {
      const element = document.querySelector(selector);

      if (element) {
        window.scrollTo({
          behavior: 'smooth',
          top:
            element.getBoundingClientRect().top -
            document.body.getBoundingClientRect().top -
            offset
        });
      } 
    }

    for (const [item, details] of Object.entries(navItems)) {
      const a11yNavItem = document.createElement('li');
      const a11yNavItemLink = document.createElement('a');
      a11yNavItemLink.id = item;

      switch (item) {
        case 'skip-to-main':
          a11yNavItemLink.addEventListener("keydown", (event) => {
            event.stopImmediatePropagation();

            const h1 = document.querySelector('h1');
            if (h1 && (event.key == "Enter")) {
              const scrollDiv = document.createElement('div');
              scrollDiv.id = 'a11y-scroll';
              scrollDiv.className = 'a11y-scroll';
              h1.parentNode?.insertBefore(scrollDiv, h1);

              let offset = 0;
              const navbar = document.querySelector('nav');
              if (navbar) {
                offset = navbar.offsetHeight;
              }
              scrollIntoViewWithOffset('a11y-scroll', offset);
              scrollDiv.setAttribute('tabindex', '-1');
              scrollDiv.focus();
            }
          });
          break;
        case 'skip-to-a11y':
          a11yNavItemLink.addEventListener("keydown", (event) => {
            event.stopImmediatePropagation();
            if (event.key == "Enter") {
              document.getElementById('a11y-menu-toggle')?.focus();
            }
          });
          break;
      }

      if (details.href) {
        a11yNavItemLink.href = details.href;

        if (details.target) {
          a11yNavItemLink.target = details.target;
        }
      }
      a11yNavItemLink.tabIndex = 0;
      a11yNavItemLink.textContent = details.label;
      let translationKey = '';
      switch (item) {
        case 'skip-to-main':
          translationKey = 'skipToMain'; break;
        case 'skip-to-a11y':
          translationKey = 'skipToA11y'; break;
        case 'go-to-a11y-disclaimer':
          translationKey = 'a11yDisclaimer'; break;
        case 'go-to-a11y-contact':
          translationKey = 'a11yContact'; break;
      }
      a11yNavItemLink.setAttribute('data-translation-field', 'true');
      a11yNavItemLink.setAttribute('data-translation-key', translationKey);
      a11yNavItem.appendChild(a11yNavItemLink);
      a11yNav.appendChild(a11yNavItem);
    }

    document.body.insertBefore(a11yNav, document.body.firstChild);
  });
}